import { ordersTypes } from '../types';
import { getDataFromDB, getSelectedData } from '../services/orders';
import { getToken } from 'helpers';
import { setRedirect } from './redirect';

export const getData = (page) => async (dispatch) => {
    dispatch({ type: ordersTypes.GET_DATA_REQUEST });
    const token = await getToken();

    if (!token) {
        dispatch(setRedirect('/login'));
    }

    return getDataFromDB({ page })
        .then((payload) => {
            dispatch({ type: ordersTypes.GET_DATA_SUCCESS, payload });
        })
        .catch((error) => {
            console.error(error);
            dispatch({ type: ordersTypes.GET_DATA_FAIL, error });
        });
};

export const getOrderData = (id) => async (dispatch) => {
    dispatch({ type: ordersTypes.GET_ORDER_REQUEST, id });

    return getSelectedData(id)
        .then((order) => {
            setTimeout(() => {
                dispatch({ type: ordersTypes.GET_ORDER_SUCCESS, order });
            }, 1000);
        })
        .catch((error) => {
            console.error(error);
            dispatch({ type: ordersTypes.GET_ORDER_FAIL, error });
        });
};

export const clearData = async (dispatch) => dispatch({ type: ordersTypes.CLEAR });
